import { createStyles } from '@material-ui/core';
import Grid from '@material-ui/core/Grid';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import React, { FunctionComponent } from 'react';
import compose from 'recompose/compose';
import pure from 'recompose/pure';
import { SelectButton } from '../SelectButton';

interface OwnProps {
  selected?: boolean;
  onSelect?: () => any;
}

interface SelectColumnProps extends OwnProps, WithStyles<typeof styles> {}

const SelectColumnBase: FunctionComponent<SelectColumnProps> = ({
  classes,
  selected,
  onSelect,
}) => {
  return (
    <Grid
      container
      item
      xs
      zeroMinWidth
      justify="flex-end"
      alignItems="center"
      direction="row"
      className={classes.center}
    >
      <Grid item>
        <SelectButton selected={selected} onSelect={onSelect} />
      </Grid>
    </Grid>
  );
};

// styled
const styles = createStyles({
  center: {
    height: '100%',
  },
});

const enhance = compose<SelectColumnProps, OwnProps>(
  pure,
  withStyles(styles),
);

export const SelectColumn = enhance(SelectColumnBase);

SelectColumn.displayName = 'SelectColumn';
